import { render, staticRenderFns } from "./FulfillmentResetPassword.vue?vue&type=template&id=65238c89"
import script from "./FulfillmentResetPassword.vue?vue&type=script&lang=js"
export * from "./FulfillmentResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports